onReady(() => window.addEventListener('click', (event) => dataLayer.push({
    event: 'all-elements-click',
    elementId: event.target.id,
    destinationURL: event.target.href,
    elementClasses: event.target.classList.toString(),
    elementType: event.target.nodeName,
    elementContent: event.target.innerText,
})));
